module.exports = "pegasus/assets/graycircle-snapchat.png";